module.exports = __webpack_public_path__ + "img/feiyuhan.77291cda.jpg";